export var CostLayerStatus;
(function (CostLayerStatus) {
    CostLayerStatus[CostLayerStatus["OPEN"] = 1] = "OPEN";
    CostLayerStatus[CostLayerStatus["CLOSED"] = 2] = "CLOSED";
})(CostLayerStatus || (CostLayerStatus = {}));
//# sourceMappingURL=cost-layer-status.js.map